module.exports = __webpack_public_path__ + "static/media/scale.2ffe7b8e.svg";